import React from 'react';

import { useTranslation } from 'react-i18next';
import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import Tags from '../../Tags';
import { taxonomyTagEntityMapper } from '../../Tags/taxonomyTagMapper';
import type { TaxonomyDepartment } from '../../../types/uncinc_profile/taxonomy';

export interface DepartmentProps {
  departments: ReferenceField<TaxonomyDepartment>[];
}

const Department: React.FC<DepartmentProps> = (props) => {
  const { t } = useTranslation();
  const { departments } = props;

  return (
    <div className="ArticleMetadata__department">
      <div className="ArticleMetadata__department__label">
        {t('taxonomies.departments.title', { count: departments.length })}
      </div>
      <Tags items={taxonomyTagEntityMapper(departments)} />
    </div>
  );
};

export default Department;
